import {getCountries, getCities} from '../helpers/geoService';
import { checkError, receiveErrorAlert, closeAlert } from './commonsActions';

/*
 * action types
 */

export const FETCH_COUNTRIES_BEGIN   = 'FETCH_COUNTRIES_BEGIN';
export const FETCH_COUNTRIES_SUCCESS = 'FETCH_COUNTRIES_SUCCESS';
export const FETCH_COUNTRIES_ERROR = 'FETCH_COUNTRIES_ERROR';

export const FETCH_CITIES_BEGIN   = 'FETCH_CITIES_BEGIN';
export const FETCH_CITIES_SUCCESS = 'FETCH_CITIES_SUCCESS';
export const FETCH_CITIES_ERROR = 'FETCH_CITIES_ERROR';

/*
 * action creators
 */


export const fetchCountries = query => dispatch => {
    dispatch({
        type: FETCH_COUNTRIES_BEGIN
    });
    return getCountries(query).then(res => {
        dispatch({
            type: FETCH_COUNTRIES_SUCCESS,
            payload: {
                countries: res.data.countryInfos,
            }
        });
        return res
    }, error => {
        dispatch(checkError(error));
        dispatch(receiveErrorAlert('No data')); // error message
        setTimeout(() => {
            dispatch(closeAlert());
            dispatch({
                type: FETCH_COUNTRIES_ERROR
            })
        }, 2000);
    })
};

export const fetchCities = query => dispatch => {
    dispatch({
        type: FETCH_CITIES_BEGIN
    });
    return getCities(query).then(res => {
        dispatch({
            type: FETCH_CITIES_SUCCESS,
            payload: {
                cities: res.data.cities,
            }
        });
        return res
    }, error => {
        dispatch(checkError(error));
        dispatch(receiveErrorAlert('No data')); // error message
        setTimeout(() => {
            dispatch(closeAlert());
            dispatch({
                type: FETCH_CITIES_ERROR
            })
        }, 2000);
    })
};




// WEBPACK FOOTER //
// ./src/actions/geoActions.js